import { value } from '@takeshape/util';
import { updateAuthentication } from "../util/authentication.js";
import { hasEveryKey } from "../util/has.js";
import { endpointWithPath, getHealthCheck } from "../util/health.js";
const name = 'yotpoLoyalty';
const title = 'Yotpo Loyalty';
const namespace = 'YotpoLoyalty';
export const specUrl = 'https://raw.githubusercontent.com/takeshape/openapi-specs/955c16158e06cbef398e7470018a397a16af3c2f/specs/yotpo/loyalty.yml';
const serviceProvider = {
    name,
    title,
    description: 'Yotpo’s eCommerce retention marketing platform drives repeat shopper sales with connected solutions for reviews, SMS, email, loyalty, and subscriptions.',
    categories: ['ecommerce'],
    links: [{ title: 'Homepage', url: 'https://www.yotpo.com/' }],
    serviceType: 'openapi',
    introspectionType: 'openapi',
    createId: value(name),
    getFormSchema: value({
        type: 'object',
        properties: {
            id: {
                title: 'Slug',
                type: 'string',
                pattern: '[0-9A-Za-z_-]+',
                default: 'yotpo-loyalty'
            },
            title: {
                title: 'Name',
                type: 'string',
                default: title
            },
            namespace: {
                title: 'Namespace',
                type: 'string',
                pattern: '^[A-Z][A-Za-z]+$',
                default: namespace
            },
            authentication: {
                title: 'Authentication',
                type: 'object',
                properties: {
                    guid: {
                        title: 'GUID',
                        type: 'string'
                    },
                    apiKey: {
                        title: 'API Key',
                        type: 'string',
                        '@sensitive': true
                    }
                },
                required: ['guid', 'apiKey']
            }
        },
        required: ['title', 'id', 'namespace', 'authentication']
    }),
    getFormConfig: value({
        order: ['title', 'id', 'namespace', 'guid', 'authentication'],
        properties: {
            title: {
                widget: 'singleLineText',
                instructions: 'Human-readable identifier for use in the UI.'
            },
            namespace: {
                widget: 'singleLineText',
                instructions: 'A pascal-case prefix that will be added to types in your API.'
            },
            id: {
                widget: 'singleLineText',
                instructions: 'Unique identifier for use in the API and Schema.'
            },
            authentication: {
                properties: {
                    guid: {
                        widget: 'sensitiveField',
                        instructions: 'Find your GUID in [Loyalty Settings](https://loyalty-app.yotpo.com/general-settings)'
                    },
                    apiKey: {
                        widget: 'sensitiveField',
                        instructions: 'Find your API Key in [Loyalty Settings](https://loyalty-app.yotpo.com/general-settings)'
                    }
                },
                order: ['guid', 'apiKey']
            }
        }
    }),
    getConfig(formData) {
        const config = {
            title: formData.title ?? title,
            namespace: formData.namespace ?? namespace,
            provider: 'yotpoLoyalty',
            serviceType: 'openapi',
            authenticationType: 'custom',
            options: {
                endpoint: 'https://loyalty.yotpo.com',
                spec: specUrl
            }
        };
        return updateAuthentication(config, formData, { type: 'bearer' });
    },
    getCustomAuthInfo(authentication) {
        return [
            [['headers', 'x-guid'], authentication.guid],
            [['headers', 'x-api-key'], authentication.apiKey]
        ];
    },
    isCompleteConfig: hasEveryKey(['authentication', 'options.endpoint', 'options.spec']),
    getHealthCheck: getHealthCheck({
        checkName: 'ping',
        endpoint: endpointWithPath('/api/v2/customers/recent')
    })
};
export default serviceProvider;
